// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__300oK","name":"Header_name__1_haf","birthday":"Header_birthday__hxNG0","skeleton":"Header_skeleton__2uPt3"};